import React, { memo } from 'react'
import Helmet from 'next/head'
import PropTypes from 'prop-types'

import { Constants } from '../../adapters/helpers/Constants';
import { customJsonstringify } from '../../adapters/helpers/Utils';
import DOMPurify from 'isomorphic-dompurify';

const FAQSchema = ({ faqs, faqdetails, isfaqPagecomponent }) => {
    const itemList = faqs?.map(faq => ({     
        '@type':  `${Constants.Question}`,
        'name': `${faq?.fields?.name}`,
        'acceptedAnswer': {
            '@type': `${Constants.Answer}`,
            'text': `${faq?.fields?.answer}`
        }
    }))
    const renderFaqItem =(item)=>({       
        '@type':  `${Constants.Question}`,
        'name': `${item?.question}`,
        'acceptedAnswer': {
            '@type': `${Constants.Answer}`,
            'text': `${item?.answer}`
        }
    })

    return (
        <Helmet>
            <script
            type={Constants.typeLD}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(`{
                            "@context":"${Constants.context}",
                            "@type": "${Constants.FAQ}",
                            "mainEntity": ${isfaqPagecomponent?customJsonstringify(renderFaqItem(faqdetails?.props)):customJsonstringify(itemList)}
                        }`)
                }}
            />
        </Helmet>
    )
}

FAQSchema.propTypes = {
    faqs: PropTypes.array.isRequired,
    faqdetails:PropTypes.isRequired
}

export { FAQSchema}

export default memo(FAQSchema)
